"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var helpers_1 = require("../../helpers");
var StackView_1 = require("../../StackView");
var controls_1 = require("./..");
var InputBox_1 = require("../helpers/InputBox");
var InputControl_1 = require("../helpers/InputControl");
var LinkButton_1 = require("../LinkButton");
var icons_1 = require("../../icons");
var public_1 = require("../../common/public");
exports.MIN_WIDTH_FILE_INPUT = helpers_1.FIELD_XXS;
var StyledInputBox = styled_components_1.default(InputBox_1.InputBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), exports.MIN_WIDTH_FILE_INPUT);
var defaultTextValueFormatter = function (fileList) {
    return fileList ? Array.from(fileList, function (file) { return file.name; }).join(', ') : '';
};
exports.FileInput = helpers_1.createUIElement('FileInput', function (_a, ref) {
    var className = _a.className, _b = _a.hideInput, hideInput = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? public_1.CONTROL_SIZE.m : _e, _f = _a.placeholder, placeholder = _f === void 0 ? 'Select file' : _f, _g = _a.iconSrc, iconSrc = _g === void 0 ? react_1.default.createElement(icons_1.FolderClosedIcon, null) : _g, _h = _a.buttonText, buttonText = _h === void 0 ? 'Browse...' : _h, accept = _a.accept, _j = _a.multiple, multiple = _j === void 0 ? false : _j, onChange = _a.onChange, _k = _a.formatTextValue, formatTextValue = _k === void 0 ? defaultTextValueFormatter : _k, value = _a.value, onButtonClick = _a.onButtonClick, onFocus = _a.onFocus, onBlur = _a.onBlur, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "hideInput", "disabled", "error", "size", "placeholder", "iconSrc", "buttonText", "accept", "multiple", "onChange", "formatTextValue", "value", "onButtonClick", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var preventBlur = false;
    var fileValueState = helpers_1.useStateValue(value, [value]);
    var fileInputRef = react_1.useRef(null);
    var inputRef = react_1.useRef(null);
    var handleClick = function () {
        var _a;
        preventBlur = true;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick();
    };
    var handleChangeValue = function (e) {
        var files = e.target.files;
        onChange === null || onChange === void 0 ? void 0 : onChange(files);
        fileValueState.setValue(files);
    };
    return (react_1.default.createElement(StackView_1.StackView, __assign({}, helpers_1.clearProps(rest), { "data-selector-id": rest['data-selector-id'], className: "vm-FileInput " + className, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.m, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        !hideInput && (react_1.default.createElement(StyledInputBox, { tabIndex: -1, size: size, isDisabled: disabled, hasError: error },
            react_1.default.createElement(InputControl_1.InputControl, { tabIndex: -1, "data-selector-id": "input-control", ref: inputRef, value: formatTextValue(fileValueState.getValue()), placeholder: placeholder, disabled: disabled, type: controls_1.INPUT_TYPE.text, readOnly: true }))),
        react_1.default.createElement(LinkButton_1.LinkButton, { "data-selector-id": "select-link", disabled: disabled, onClick: handleClick, iconBefore: iconSrc, error: hideInput && error, onKeyDown: function (e) {
                if (e.keyCode === helpers_1.KeyCode.Enter || e.keyCode === helpers_1.KeyCode.Space) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleClick();
                }
            }, onFocus: onFocus, onBlur: function (e) {
                if (preventBlur) {
                    preventBlur = false;
                    return;
                }
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
            } }, buttonText),
        react_1.default.createElement("input", { 
            /* key as a random number is required to constantly recreate during rendering */
            key: Math.random().toString(16), "data-selector-id": "native-file-input", type: "file", disabled: disabled, multiple: multiple, onChange: handleChangeValue, accept: accept, ref: fileInputRef, hidden: true })));
});
var templateObject_1;
//# sourceMappingURL=FileInput.js.map